// extracted by mini-css-extract-plugin
export default {"wrapper":"hgu6EmKs8IQLctoC1cyt","inner":"eu8xrvW9fDS44ZF9PrWn","tagline":"GkvcniHE5T_uBSe23hkZ","headline":"MEuNhRDS4B8iyZxZgSIN"};